import React from 'react';
import { CenteredDiv } from '../decorated-elements';
import { l10n } from '../with-app-root/i18n/i18nUtil';
import './PageUnknown.css';

const PageUnknown: React.FC = () => {
  return (
    <CenteredDiv>
      <div className="page-unknown">
        <clr-icon
          class="page-unknown-icon"
          shape="neutral-face"
          size="256"
          title={l10n('components.bootLoader.unknownMessage')}
        />
        <span className="page-unknown-message">
          {l10n('components.pageUnknown.pageUnknownMessage')}
        </span>
      </div>
    </CenteredDiv>
  );
};

export default PageUnknown;
